import './style.scss';
import { unbindBeneficiary } from '../../API/apiService';
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';

function DeleteBeneficiaryModal({ user, setOpenModalDelete }) {
  const [inputValue, setInputValue] = useState('');
  const navigate = useNavigate();
  async function deleteBeneficiary() {
    const response = await unbindBeneficiary(user.id);
    if (response) {
      setOpenModalDelete(false);
      navigate(`/escuelas/grupo/${user.group?.id}/school/${user.school?.id}`);
    }
  }

  function handleInputChange(event) {
    const value = event.target.value;
    if (value) {
      setInputValue(value.toString().trim());
    } else {
      setInputValue(value);
    }
  }

  return (
    <>
      <section className='modal-info-container'>
        <button
          onClick={() => setOpenModalDelete(false)}
          className='button-close'>
          <svg
            xmlns='http://www.w3.org/2000/svg'
            width='20.98'
            height='20.981'
            viewBox='0 0 20.98 20.981'>
            <g id='Icon-close' transform='translate(-308.562 -311.686)'>
              <path
                id='Trazado_679'
                data-name='Trazado 679'
                d='M-4680.317,593.807l16.738,16.738'
                transform='translate(4991 -280)'
                stroke='#bcbcbc'
                strokeLinecap='round'
                strokeWidth='3'
              />
              <path
                id='Trazado_680'
                data-name='Trazado 680'
                d='M-4663.579,593.807l-16.738,16.738'
                transform='translate(4991 -280)'
                fill='none'
                stroke='#bcbcbc'
                strokeLinecap='round'
                strokeWidth='3'
              />
            </g>
          </svg>
        </button>
        <div className='info-container'>
          <h2 className='title'>Desvincular Beneficiario del Grupo</h2>
          <p className='text'>{user.full_name}</p>
          <p className='text'>
            Motivo <span>*</span>
          </p>
          <input
            className='input'
            type='text'
            value={inputValue}
            onChange={handleInputChange}
          />
          <div className='button-container'>
            <button
              className='blue-site-button but'
              onClick={deleteBeneficiary}>
              DESVINCULAR
            </button>
          </div>
        </div>
      </section>
    </>
  );
}

export default DeleteBeneficiaryModal;